// 定义内容
export default {
	introTitleUIE: 'YAYI-UIE精准的',
	introTitleExtrac: '知识抽取',
	introTitleAI: 'AI助手',
	introTitleMain: '基于百万级中英双语料，结合有监督微调与人类意图对齐，在信息抽取领域表现突出，支持舆情、媒宣、金融、安全等领域复杂场景信息抽取。',
	enterkeyword: '输入关键词',
	enterDetail: '进入',
	extractInfor: '抽取信息',
	extractContent: '抽取内容',
	extractResults: '抽取结果',
	copyJSON: '复制JSON',
	extractionProgress: '正在抽取中',
	sendExtractedView: '左侧发送抽取内容后查看',
	record: '记录',
	historyRecord: '历史记录',
	confirmDeletSession: '确认删除此会话',
	confirm: '确认',
	cancel: '取消',
	submit: '提交',
	nohistory: '暂无历史记录',
	feedbackMeansLot: '您的反馈对我们意义重大，希望您填写您认为',
	moreDesAnswer: '您认为更理想的答案是什么？',
	abnormalNetwork: '当前网络异常，请检查网络',
	copySuccessful: '复制成功',
	likeSuccess: '点赞成功',
	tapSuccess: '点踩成功',
	hisNameNoEmpty: '历史记录名称不能为空'
};
